// "Sticky contact": remember the lead's details after they finish the survey so
// the booking calendar on the next page is pre-filled and the appointment binds
// to the same GHL contact instead of creating a duplicate.
const KEY = "rd_sticky_contact";

export type StickyContact = {
  name: string;
  email: string;
  phone: string;
  timezone: string;
  savedAt: number;
};

export function saveStickyContact(c: {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  timezone?: string | null;
}) {
  if (typeof window === "undefined") return;
  try {
    const payload: StickyContact = {
      name: (c.name ?? "").trim(),
      email: (c.email ?? "").trim(),
      phone: (c.phone ?? "").trim(),
      timezone: (c.timezone ?? "").trim(),
      savedAt: Date.now(),
    };
    window.localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* storage unavailable */
  }
}

export function readStickyContact(): StickyContact | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StickyContact>;
    if (!parsed || typeof parsed !== "object") return null;
    return {
      name: typeof parsed.name === "string" ? parsed.name : "",
      email: typeof parsed.email === "string" ? parsed.email : "",
      phone: typeof parsed.phone === "string" ? parsed.phone : "",
      timezone: typeof parsed.timezone === "string" ? parsed.timezone : "",
      savedAt: typeof parsed.savedAt === "number" ? parsed.savedAt : 0,
    };
  } catch {
    return null;
  }
}

/**
 * Query params the GHL booking widget reads to pre-fill (and stick to) a
 * contact. Timezone is included so the calendar shows slots in the lead's own
 * timezone and the booking is stored against it.
 */
export function stickyCalendarParams(c: {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  timezone?: string | null;
}): URLSearchParams {
  const parts = (c.name ?? "").trim().split(/\s+/).filter(Boolean);
  const params = new URLSearchParams();
  params.set("first_name", parts[0] ?? "");
  params.set("last_name", parts.slice(1).join(" "));
  params.set("email", (c.email ?? "").trim());
  params.set("phone", (c.phone ?? "").trim());
  const tz = (c.timezone ?? "").trim();
  if (tz) {
    params.set("timezone", tz);
    params.set("timeZone", tz);
  }
  return params;
}
